import React from 'react';
import { FiPlus } from 'react-icons/fi';
import PosProductCard from './PosProductCard';

const PosSlotGrid = ({
  slots = [],
  onSelect,
  onAddSlot,
  showAddSlot = false,
  emptyLabel = 'No hay favs configurados.',
  variant = 'default',
}) => {
  const hasSlots = Array.isArray(slots) && slots.length > 0;
  const isCompact = variant === 'compact';

  return (
    <div className={isCompact
      ? 'grid grid-cols-3 gap-2 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-8'
      : 'grid grid-cols-3 gap-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10'}
    >
      {!hasSlots && !showAddSlot && (
        <div className="col-span-full rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-12 text-center text-sm text-gray-500">
          {emptyLabel}
        </div>
      )}

      {(slots || []).map((slot) => (
        <PosProductCard
          key={slot.key}
          productName={slot.productName}
          imageSrc={slot.imageSrc}
          disabled={slot.disabled}
          disabledReason={slot.invalidReason}
          onClick={() => onSelect?.(slot)}
          variant={variant}
        />
      ))}

      {showAddSlot && (
        <button
          type="button"
          onClick={() => onAddSlot?.()}
          className="flex aspect-square flex-col items-center justify-center rounded-2xl border border-dashed border-blue-300 bg-blue-50 px-2 py-3 text-center text-blue-700 transition hover:bg-blue-100"
        >
          <span className={`flex items-center justify-center rounded-full bg-white text-blue-700 shadow-sm ${isCompact ? 'h-10 w-10' : 'h-12 w-12'}`}>
            <FiPlus size={20} />
          </span>
        </button>
      )}
    </div>
  );
};

export default PosSlotGrid;
